import React from "react";
import { MapPin, ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from "lucide-react";

const DIR_LABEL = { N: "North", S: "South", E: "East", W: "West" };
const DIR_ICON  = { N: ArrowUp, S: ArrowDown, E: ArrowRight, W: ArrowLeft };

const formatTime = (raw) => {
  if (!raw) return "—";
  const dt = new Date(raw.replace(" ", "T"));
  if (isNaN(dt)) return raw;
  return dt.toLocaleString("en-IN", {
    day: "2-digit", month: "short",
    hour: "2-digit", minute: "2-digit", hour12: false,
  });
};

const TransactionSidebar = ({ transactions, selectedTransaction, onTransactionSelect }) => {
  return (
    <div className="w-64 flex-shrink-0 bg-white border-r border-slate-200 flex flex-col overflow-hidden">

      {/* Header */}
      <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between flex-shrink-0">
        <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Toll Transactions</span>
        <span className="text-xs font-bold bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">
          {transactions.length}
        </span>
      </div>

      {/* List */}
      <div className="overflow-y-auto flex-1">
        {transactions.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full gap-2 text-slate-300 py-12">
            <MapPin size={28} strokeWidth={1.5} />
            <p className="text-xs text-slate-400">No transactions</p>
          </div>
        ) : (
          transactions.map((txn, index) => {
            const isSelected = selectedTransaction?.seqNo === txn.seqNo;
            const DirIcon    = DIR_ICON[txn.laneDirection] || MapPin;
            const isFirst    = index === transactions.length - 1; // oldest = start
            const isLast     = index === 0;                       // newest = end

            return (
              <button
                key={txn.seqNo || index}
                onClick={() => onTransactionSelect(txn)}
                className={`w-full text-left flex items-center gap-3 px-4 py-3 border-b border-slate-100 transition-colors
                  ${isSelected
                    ? "bg-amber-50 border-l-[3px] border-l-amber-400"
                    : "hover:bg-slate-50 border-l-[3px] border-l-transparent"
                  }`}
              >
                {/* Index badge — matches map marker style */}
                <span className={`w-6 h-6 flex-shrink-0 rounded-full flex items-center justify-center text-[10px] font-bold border-2
                  ${isFirst
                    ? "bg-emerald-600 border-emerald-600 text-white"
                    : isLast
                    ? "bg-sky-700 border-sky-700 text-white"
                    : isSelected
                    ? "bg-amber-400 border-amber-400 text-slate-900"
                    : "bg-white border-slate-300 text-slate-500"
                  }`}>
                  {isFirst ? "S" : isLast ? "E" : index + 1}
                </span>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <p className={`text-xs font-semibold truncate ${isSelected ? "text-amber-700" : "text-slate-700"}`}>
                    {txn.tollPlazaName || "Unknown Plaza"}
                  </p>
                  <p className="text-[10px] text-slate-400 mt-0.5">{formatTime(txn.readerReadTime)}</p>
                </div>

                {/* Direction badge */}
                <span className={`flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded flex-shrink-0
                  ${isSelected ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-500"}`}>
                  <DirIcon size={9} />
                  {DIR_LABEL[txn.laneDirection]?.charAt(0) || txn.laneDirection || "—"}
                </span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default TransactionSidebar;